const LABELS = {
  CONTACT_US: "Contact Us",
};

export default LABELS;
